module.exports = __webpack_public_path__ + "imgs/ggMobile2x.ba56758a.webp";